import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { take } from 'rxjs';
import { ResumeSource, ResumeType } from '../../../core/resume/resume';
import { ResumeService } from '../../../core/resume/resume.service';

@Component({
  selector: 'app-generate-resume-text-input',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzModalModule,
    NzButtonModule,
    NzInputModule,
    NzPopconfirmModule,
    NzTagModule,
    NzCollapseModule,
    NzTagModule,
    MatTooltip,
    NzPopoverModule,
    NzTabsModule,
    NzDividerModule,
    NzSkeletonModule,
    NzRadioModule,
  ],
  templateUrl: './generate-resume-text-input.component.html',
  styleUrl: './generate-resume-text-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateResumeTextInputComponent {
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  customerInfo: string = '';

  ResumeType = ResumeType;
  resumeType: ResumeType = ResumeType.real;

  isLoading = signal(false);

  constructor(private resumeService: ResumeService) {}

  onIsVisibleChange(isVisible: boolean) {
    this.isVisibleChange.emit(isVisible);
  }

  onCancelClick() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }

  onGenerateClick() {
    this.isLoading.set(true);

    this.resumeService
      .addResumeFromTextInput$(this.customerInfo, this.resumeType, { resumeSource: ResumeSource.manual })
      .pipe(take(1))
      .subscribe(() => {
        this.isLoading.set(false);
        this.isVisible = false;
        this.isVisibleChange.emit(this.isVisible);
      });
  }
}
